import { createHook, createStore } from '@atlassian/react-sweet-state';
import messages from './messages';
import { getUrl } from './utils';

interface PriorityOption {
	label: string;
	value: string;
	icon: string;
}

const store = createStore({
	initialState: {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		values: [] as Array<PriorityOption>,
		loading: false,
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		error: null as unknown,
	},
	actions: {
		fetchPriorities:
			(baseUrl, projectId, formatMessage) =>
			async ({ setState }) => {
				setState({
					loading: true,
				});
				try {
					const rawResponse = await fetch(getUrl(baseUrl, projectId));
					const textResponse = await rawResponse.text();
					const data = textResponse ? JSON.parse(textResponse) : null;
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					const options = data.values.map((value: any) => ({
						label: value.name,
						value: value.name,
						icon: value.iconUrl,
					}));
					const optionsWithNone = [
						...options,
						{
							label: formatMessage(messages.none),
							value: 'EMPTY',
							icon: '',
						},
					];
					setState({
						values: optionsWithNone,
					});
				} catch (e) {
					setState({
						error: e,
					});
				} finally {
					setState({
						loading: false,
					});
				}
			},
	},
	name: 'Priorities',
});

export const useFetchPrioritiesService = createHook(store);
